import * as fromAttachments from './attachments/attachments.reducer';
import * as fromConfig from './config/config.reducer';
import * as fromAgreements from './agreements/agreements.reducer';
import * as fromPayments from './payments/payments.reducer';
import * as fromProcess from './process/process.reducer';
import * as fromRemote from './remote/remote.reducer';
import * as fromRequestCounter from './requestCounter/requestCounter.reducer';
import * as fromSaveContact from './save-contact/save-contact.reducer';
import * as fromInsuredImport from './insured-import/insured-import.reducer';
import { ActionReducer, INIT, UPDATE } from '@ngrx/store';
import { PersistStorageKeys, PersistStorageService } from '../services/persist-storage.service';

const STORE_VERSION = '12';

export interface AppState {
  attachments: fromAttachments.State;
  config: fromConfig.State;
  agreements: fromAgreements.State;
  payments: fromPayments.State;
  process: fromProcess.State;
  remote: fromRemote.State;
  requestCounter: fromRequestCounter.State;
  saveContact: fromSaveContact.State;
  insuredImport: fromInsuredImport.State;
}

const appStore = {
  attachments: fromAttachments.reducer,
  config: fromConfig.reducer,
  agreements: fromAgreements.reducer,
  payments: fromPayments.reducer,
  process: fromProcess.reducer,
  remote: fromRemote.reducer,
  requestCounter: fromRequestCounter.reducer,
  saveContact: fromSaveContact.reducer,
  insuredImport: fromInsuredImport.reducer,
};

export const appStoreMocks: AppState = {
  attachments: fromAttachments.initialState,
  config: fromConfig.initialState,
  agreements: fromAgreements.initialState,
  payments: fromPayments.initialState,
  process: fromProcess.initialState,
  remote: fromRemote.initialState,
  requestCounter: fromRequestCounter.initialState,
  saveContact: fromSaveContact.initialState,
  insuredImport: fromInsuredImport.initialState,
};

export const hydrationMetaReducer =
  (reducer: ActionReducer<AppState>): ActionReducer<AppState> =>
  (state, action) => {
    const persistStorage = new PersistStorageService();

    if (STORE_VERSION !== persistStorage.getString(PersistStorageKeys.StoreVersion)) {
      persistStorage.removeAll();
      persistStorage.setString(PersistStorageKeys.StoreVersion, STORE_VERSION.toString());
      location.reload();
    }

    if (action.type === INIT || action.type === UPDATE) {
      const storageValue = persistStorage.getJson<AppState>(PersistStorageKeys.Store);

      if (storageValue) {
        storageValue.requestCounter.requestCounter = 0;
      }

      if (storageValue) {
        try {
          return storageValue;
        } catch {
          persistStorage.removeItem(PersistStorageKeys.Store);
        }
      }
    }
    const nextState = reducer(state, action);
    persistStorage.setJson(PersistStorageKeys.Store, nextState);

    return nextState;
  };

export default appStore;
